import { render } from "./process.vue?vue&type=template&id=3abf2cca"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=3abf2cca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__